import { create } from 'zustand';
import type { CutoutTier } from '../api/types';

export interface RegisteredRow {
  product_id: string;
  image_link: string | null;
  cutout_tier: CutoutTier | null;
}

interface RegistryState {
  rows: Map<string, RegisteredRow>;
  upsert: (row: RegisteredRow) => void;
  clear: () => void;
}

export const useRowsRegistry = create<RegistryState>((set) => ({
  rows: new Map(),
  upsert: (row) => set((s) => {
    const next = new Map(s.rows);
    next.set(row.product_id, row);
    return { rows: next };
  }),
  clear: () => set({ rows: new Map() }),
}));
